"use client"
import React, { useEffect } from 'react';
import { Grid, Box, Paper, Container, Button, Badge } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setContactUs } from 'api/session';

const TextOnImage = () => {

    const trademarkSymbol = '\u2122';
    const dispatch = useDispatch();
    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={false}
            sx={{
                //position: "absolute",
                backgroundColor: "transparent",
                //marginTop: "-500px",
                //marginLeft: "200px",
                padding: "40px 20px 40px 20px",
                display: {
                    //xs: 'none',
                    md: "flex"
                }
            }}
        >
            <Grid container item direction={"column"} justifyContent="center" alignItems={"center"}>
                <Grid container item direction={"row"} justifyContent="center" alignItems={"center"}>
                    <Box
                        align="center"
                        sx={{
                            color: "#000",
                            backgroundColor: "transparent",
                            //width: "450px",
                            fontWeight: "500",
                            fontSize: {
                                xs: "35px",
                                sm: "50px"
                            },
                            paddingRight: "20px"
                        }}
                        variant={'h2'}
                    >
                        Tirefax Safety Alerts<sup style={{ fontSize: "20px" }}>{trademarkSymbol}</sup>
                    </Box>
                    <Box

                        sx={{
                            marginTop: "-20px",
                            marginLeft: "-20px",
                            color: "#fff",
                            backgroundColor: "transparent",
                            //width: "450px",
                            //fontWeight: "500",
                            fontSize: "16px",
                            //paddingRight: "20px"
                        }}
                        variant={'h2'}
                    >&trade;</Box>
                </Grid>
                <Button
                    onClick={() => dispatch(setContactUs(true))}
                    sx={{
                        fontSize: "18px",
                        fontWeight: "400",
                        //marginLeft: "60px",
                        width: "350px",
                        marginTop: "20px",

                    }}
                    color="warning"
                    variant='contained'
                //size='small'
                >
                    Request Tirefax Demo
                </Button>
            </Grid>
        </Container>
    )
}

export default TextOnImage;